import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient} from '@angular/common/http';
import { Util } from '../util.service';

@Injectable({
  providedIn: 'root'
})

export class ExamtypeService {
  baseurl = Util.GetBaseUrl();

  constructor(private http: HttpClient, public router: Router) { }
  
  viewExamType() {
    return this.http.get(this.baseurl +'/api/ExamTypes/GetExamTypes')
  }

  addExamType(examTypeForm) {
    console.log(examTypeForm);
    return this.http.post(this.baseurl+'/api/ExamTypes', examTypeForm)
  }

  editExamType(id, examTypeForm) {
    console.log(examTypeForm);
    return this.http.put(this.baseurl+`/api/ExamTypes/${id}`, examTypeForm)
  }

  deleteExamType(id) {
    console.log(id);
    return this.http.delete(this.baseurl+`/api/ExamTypes/${id}`)
  }
}
